import { useMutation } from "@shared/lib/hooks";
import { DeliverableConfiguratorService } from "../services/deliverable.configurator.service";
import { ICreateDeliverableFormat } from "@shared/lib/types";
import { DELIVERABLE_CONFIGURATOR_QUERY_KEY } from "../constants";

export default function useCreateDeliverableFormat() {
  const {
    mutate: createDeliverableFormat,
    isLoading: isCreateDeliverableFormatLoading,
    error: createDeliverableFormatError,
    isSuccess: isCreateDeliverableFormatSuccess,
  } = useMutation({
    mutationFn: (data: ICreateDeliverableFormat) =>
      DeliverableConfiguratorService.createDeliverableFormat(data),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: [...DELIVERABLE_CONFIGURATOR_QUERY_KEY],
      });
    },
  });

  return {
    createDeliverableFormat,
    isCreateDeliverableFormatLoading,
    isCreateDeliverableFormatSuccess,
    createDeliverableFormatError,
  };
}
